import { r as registerInstance, h, H as Host, g as getElement } from './index-16dc7dde.js';

const pesRuntimeBaseCellCss = ":host{display:block}::slotted([slot=error]){margin-top:6px;color:#b10043}.runtime-base-cell__value{line-height:30px}";

let RuntimeBaseCell = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, null, h("div", { class: "runtime-base-cell__value" }, h("slot", { name: "value" })), h("div", { class: "runtime-base-cell__error" }, h("slot", { name: "error" }))));
  }
  get el() { return getElement(this); }
};
RuntimeBaseCell.style = pesRuntimeBaseCellCss;

export { RuntimeBaseCell as pes_runtime_base_cell };
